import { call, put, takeLatest } from "redux-saga/effects";
import { callAPI, handleError, handleSuccess } from "../api/api";
import { setLoaderAction, setNotificationAction } from "../reducers/mmymSlice";
import { addHtmlTemplateAction, deleteHtmlTemplateAction, getHtmlTemplateListAction, getSingleHtmlTemplateDetailsAction, setAddHtmlTemplateAction, setDeleteHtmlTemplateAction, setHtmlTemplateListAction, setUpdateHtmlTemplateAction, updateHtmlTemplateAction } from "../reducers/htmlTemplateSlice";


/**
 * This function for call the user profile
 *
 * @param {*} payload
 */

function* getHtmlTemplateListSaga():any {
    yield put(setLoaderAction(true))
    yield put(setNotificationAction({message: [], severity: 'error'}))
    try {
        const temp = yield call<any>(callAPI, {}, 'get', 'client/preset/emails')
        console.log('temp-', temp)
        if(temp?.data){
    
            yield put(setHtmlTemplateListAction(temp?.data))
        }
    } catch (error: any) {
        console.log('Catch Error-', error)
        error?.response && handleError(error?.response)
        error?.code === "ERR_NETWORK" && handleError(error);
    }
    yield put(setLoaderAction(false));
  } 

function* addHtmlTemplateSaga(action: any): any {
    yield put(setLoaderAction(true));
    yield put(setNotificationAction({ message: [], severity: "error" }));
      try {
        const {id,sample_json_data,placeholders, ...newPayload} = action.payload; // Directly access the payload
          const apiResponse = yield call<any>(callAPI,{ payload: newPayload }, 'post', 'client/html-templates')
          console.log('apiResponse-', apiResponse)
          if(apiResponse?.success === true){
            apiResponse && handleSuccess(apiResponse);
              yield put(setAddHtmlTemplateAction(true));
            
          }
      } catch (error:any) {
          console.log('Catch Error-', error);
          error?.response && handleError(error?.response)
          error?.code === "ERR_NETWORK" && handleError(error);
          yield put(setAddHtmlTemplateAction(false));
         
      }
      yield put(setLoaderAction(false));
}

function* updateHtmlTemplateSaga(payload: { payload: any }):any {
    yield put(setLoaderAction(true))
    yield put(setNotificationAction({message: [], severity: 'error'}))
    try {
        // const {id} = payload;
        console.log("payload", payload);
        const {id,status,created_at,updated_at,sample_json_data,placeholders, ...newPayload} = payload?.payload;
        const apiResponse = yield call<any>(callAPI, {payload:newPayload}, 'put', `client/html-templates/${id}`)
        console.log('changePassword-', apiResponse)
        if (apiResponse?.success === true) {
            apiResponse && handleSuccess(apiResponse);
            yield put(setUpdateHtmlTemplateAction(true));
            yield put(setNotificationAction({message: [], severity: 'error'}))
        }
    } catch (error: any) {
        console.log('Catch Error-', error)
        error?.response && handleError(error?.response);
        error?.code === "ERR_NETWORK" && handleError(error);
        yield put(setUpdateHtmlTemplateAction(false));

    }
    yield put(setLoaderAction(false))
}

function* deleteHtmlTemplateSaga(payload: { payload: any }):any {
    yield put(setLoaderAction(true))
    yield put(setNotificationAction({message: [], severity: 'error'}))
    try {
        const {id} = payload.payload;
        console.log("payload", payload);
        const apiResponse = yield call<any>(callAPI, {}, 'delete', `client/html-templates/${id}`)
        console.log('changePassword-', apiResponse)
        if (apiResponse?.success === true) {
            apiResponse && handleSuccess(apiResponse);
            yield put(setDeleteHtmlTemplateAction(true));
            yield put(setNotificationAction({message: [], severity: 'error'}))
        }
    } catch (error: any) {
        console.log('Catch Error-', error)
        error?.response && handleError(error?.response);
        error?.code === "ERR_NETWORK" && handleError(error);
        yield put(setDeleteHtmlTemplateAction(false));

    }
    yield put(setLoaderAction(false))
}



export function* watchHtmlTemplate() {
  yield takeLatest<any>(getHtmlTemplateListAction, getHtmlTemplateListSaga);
  yield takeLatest<any>(addHtmlTemplateAction, addHtmlTemplateSaga);
  yield takeLatest<any>(updateHtmlTemplateAction, updateHtmlTemplateSaga);
  yield takeLatest<any>(deleteHtmlTemplateAction, deleteHtmlTemplateSaga);
}
